export default {
  message: {
    homePage: '首　　页',
		productIntroduction:'商品介绍',
    commodity:'产品',
		commodityHeader:'产　　品',
    companyOverview:'公司简介',
	businessOfficeName:'营业所名称',
	businessOfficeAddress:'营业所地址',
    ceramicware:'陶瓷器',
    shangpings:'葫芦瓶',
    shangpingh:'水杯',
    shangpingz:'植物',
    xianrenzhang:'仙人掌',
    taochiwan:'陶瓷碗',
    taochiquan:'陶瓷圈',
    taochibei1:'陶瓷杯',
    taochihu:'陶瓷壶',
    zhiwubei:'植物杯',
    zhiwuwan:'植物碗',
    chahu:'茶壶',
    lvchahu:'绿茶壶',
    productIntroductionp:'产品介绍',
    companyOverviewc:'公司介绍',
		huaping:'花瓶',
    Product:'产品',
    Introduction:'介绍',
    company:'公司',
    Overview:'简介',
    Companyname:'公司名称',
    Establishmentdate:'设立日',
    Sukihon:'资本金',
    millionyen:'1000万日元',
    Atable:'代表人',
    Representative:'董事长 包海',
    Businesscontents:'事业内容',
    Contents1:'花木、植物苗、陶器、生活杂货品的出口进口业务',
    Contents2:'绘画、古物、古董、美术工艺品的销售及出口进口业务',
    Contents3:'根据古物营业法的古物商',
    Contents4:'出口进口业务的代理业',
    Mainbusinesses:'主要业务包括 :',
    consult:'欢迎随时咨询',
		benshe:'本社仓库',
		dier:'第二仓库',
    home:'销售陶瓷材料的溶盘、梅盘、笔洗等绘画材料用品，特别是日本画相关的顾客。也有OEM原创画材用品制作的实绩。',
    page:'株式会社阳光（岐阜县多治见笠原町上原1254-1最新的组织培养设施生产，能以短交期·低价格提供高品质的组织培养苗。请随意咨询。',
		tosring:'株式会社サンシャイン（岐阜県多治見笠原町上原1254-1主要负责包括花木、二手、陶器、生活杂货的出口进口的相关业务请随时咨询。',
    pasring:'是酒器。开口、浅腹、卧足。杯上斗彩画雌、公鸡及雏鸡，中间用山石、兰草、牡丹，故称鸡缸杯.',
    orsring:'平安树 平安树原名兰屿肉桂,樟科,樟属常绿小乔木,是一种家庭常见的观赏性木本植物。',
    iasring:'叶片密集翠绿，临近圣诞节日开花，拥簇成团，花色丰富，是惹人喜爱的室内盆栽花卉。',
    uasring:'高达15-25米，胸径达50厘米，冠幅广展；老树常有锈褐色气根。树皮深灰色。',
    yasring:'是桑科、榕族、榕属的大乔木植物，幼时附生于其他树上，叶革质，三角状卵形，基生叶脉三出；叶柄纤细，榕果球形至扁球形',
    lasring:'压手杯',
    kasring:'鸡缸杯',
    dity:'也可以将本公司的组织培养苗作为盆苗或成品进行生产。虽然基本上是使用集装箱，但也能满足生产者的要求，请随意咨询。',
    home1:'总部位于日本陶瓷生产量第一的岐阜县美浓地区，在众多厂家的协助下，可以经营所有的陶瓷产品。',
    taochi:'由日本员工管理所有的工序，可以制造日本品质的陶器，因为地理条件非常好，所以可以顺利地向日本发货。',
		jasring:'迎客松',
		hasring:'合欢树',
		gasring:'罗汉松',
		fasring1:'杜鹃',
		xasring:'松树',
		zasring:'美人松',
		casring:'黑松',
		qasring:'金钱松',
		aasring:'马尾松',
		fasring:'雪 松',
		qq:'大板松',
		ww:'油松',
		ee:'印度松',
		rr:'五针松',
		tt:'落叶松',
		yy:'白皮松',
		uu:'钟式杯',
		ii:'压手杯',
		oo:'斗笠杯',
		pp:'圆融杯',
		aa:'竹丝杯',
		ss:'耳杯',
		dd:'鸡缸杯',
		ff:'高足杯',
		gg:'罗汉杯',
		hh:'铃铛杯',
		jj:'三秋杯',
		kk:'马蹄杯',
		ll:'高士杯',
		zz:'高足碗',
		xx:'宫碗',
		cc:'小杯',
		vv:'侧把壶',
		bb:'公道茶杯',
		nn:'急须茶壶',
		mm:'荷叶瓷碗',
		mn:'美浓烧茶壶',
		nb:'斗 笠 杯',
		bl:'罗 汉 杯',
		dl:'手绘陶瓷碗',
		dm:'提梁壶',  
		dn:'花口盘',
		db:'白泥杯',
		dc:'卧足碗',
		qw:'迎客松如人伸出一只臂膀欢迎远道而来的客人，另一只手优雅地斜插在裤兜里，雍容大度，姿态优美。',
		qe:'喜光，耐干燥瘠薄。木材红褐色，纹理直，结构细，干燥时易裂，可制家具、枕木等。',
		qr:'罗汉松属常绿针叶乔木，高达20m，胸径达60cm；树皮灰色或灰褐色，浅纵裂，成薄片状脱落；枝开展或斜展，较密。',
		qt:'双子叶植物纲、杜鹃花科、杜鹃属的常绿灌木、落叶灌木。',
		qy:'松科植物中一属，常绿乔木，稀灌木，有树脂；树皮平滑或纵裂或成片状剥落。',
		qu:'常绿乔木，高25-32米，胸径25-100厘米；下部树皮淡黄褐色至暗灰褐色，裂成不规则鳞片。',
		qi:'别名白芽松，常绿乔木，高可达30公尺，树皮带灰黑色，多数花粉随风飘出。',
		qo:'叶片条形，扁平柔软，在长枝上成螺旋状散生，在短枝上15～30枚簇生，向四周辐射平展，秋后变金黄色，圆如铜钱，因此而得名。',
		qp:'马尾松不耐腐。心边材区别不明显，淡黄褐色，长纵裂，长片状剥落；木材纹理直，结构粗；含树脂，耐水湿。',
		qa:'常绿乔木，树冠尖塔形，大枝平展，小枝略下垂。叶针形，长8－60厘米，质硬，灰绿色或银灰色，在长枝上散生，短枝上簇生。',
		qs:'大板松为常绿针叶树种，日本五针松的栽培变种之一，叶五针一束，叶色偏黄，植株矮小，姿态古朴苍劲。',
		qd:'为松科针叶常绿乔木，高达25米，胸径可达1米。树皮下部灰褐色，裂成不规则鳞块。',
		qf:'心材淡黄红褐色，边材淡黄白色，纹理直，结构较细密，材质较硬，耐久用。',
		qg:'日本五针松针叶紧密秀丽，又因长期嫁接高生长受到抑制而成灌丛状的小乔木，树枝优美，为珍贵的观赏树种。',
		qh:'冬芽近圆球形，芽鳞暗褐色，边缘具睫毛，基部芽鳞的先端具长尖头。',
		qj:'有明显的主干，枝较细长，斜展，塔形或伞形树冠；冬芽红褐色，卵圆形，无树脂。',
		wq:'倒扣似钟形，杯身高挑，器型俊逸，便于拿捏、闻香。集锁香、闻香、品饮多功能为一体，是这几年来比较流行的一种款式。',
		we:'压手杯是杯的一种样式。压手杯造型为口平坦而外撇，腹壁近于竖直，自下腹壁处内收，圈足。',
		wr:'斗笠杯造型如蓑翁之斗笠，杯口大敞，杯身大，杯足小，取其怡然自得之美线条简洁优雅，烧成难度高，于简洁中见大智，尤显珍贵。',
		wt:'外形圆润 肚略外鼓 口径略内收,其聚香和聚味的效果也更显著些,可以说是能最好品出茶叶口感的器型。',
		wy:'肚子略外鼓，口径略内收，但也比较真实和正常，但其聚香和聚味的效果明显更好一些，综合口感是最好的。',
		wu:'器具外形椭圆、浅腹、平底，两侧有半月形双耳，有时也有饼形足或高足。',
		wi:'因杯身以斗彩描绘线鸡啄早哺雏，姿态栩栩如生，辅以牡丹、兰花、柱石纹，故名。',
		wo:'它同于高足碗，上为碗形，下有高柄。又称把杯，外观美丽，实用方便。',
		wp:'外形很特别。杯口内收，端起的时候不像普通杯子可以捏在外侈的杯口，而只能握在鼓出的腹部。',
		wa:'杯口外撇，深腹，圈足，倒置似铃铛，由此而得名。',
		ws:' 敞口、浅斜式腹壁、圈足，杯身以秋菊、蝶、草组成画面，故名三秋杯。',
		wd:'马蹄杯口部和器身差不多宽度，口部略宽于器身，器身比较方正，弧线小。',
		wf:'饮酒用具。直口沿边微撇，口以下渐收敛，浅圈足造型小巧丰腴。',
		wg:'造型与高足杯相似，略大。整个造型上面就比较独特。',
		wh:'形式十分丰富，其中碗口就有多种艺术形式，而且碗体分为深腹和鼓腹两种。',
		wj:'是与大杯相对的，属于酒杯的一种类型，通常口径在8厘米以内。小杯形制小巧玲珑，制作大多比较精美。',
		aq:'侧把壶，茶器，壶身呈矮状，壶把为横柄（亦称横柄壶），与壶身、壶流皆呈九十度角，由于壶把长，故倾倒茶水时不易被烫伤，方便使用。',
		aw:'早先公道茶杯是一种饮酒容器,现在慢慢成为喝茶中不可缺少的一种茶具。',
		ae:'急须通常指的是带侧把(日语中称为“横手”)的茶壶。 带侧把形态的茶壶是日本独有的。',
		ar:'以荷花为主题纹饰，开合相间，色彩娇艳，富有变化;姿态多变，整体表现紧凑雅致',
		at:'美浓烧美浓烧是日本著名瓷器，特色鲜明，样式精致。不仅可用于日常生活，也具有收藏价值',
		ay:'造型如蓑翁之斗笠，口部大，底足小，取其怡然自得之美，线条简洁优雅。',
		au:'杯口内收,腹部圆鼓鼓的,端起的时候不像普通杯子可以捏在外侈的杯口,而只能握在鼓出的腹部。',
		ai:'是指在已成型晾干的餐具素胎上用色料绘制图案,然后再以透明釉或其他浅色面釉覆面。',
		ao:'提梁壶提梁壶小口球腹，下承三兽足，肩一侧有龙首流，肩部两部连以半月形提梁。',
		ap:'花口板沿，鼓腹，凸棱似菊瓣，圈足。胎体厚重硕大，通身开细碎纹片。',
		as:'泥色度白,粘性更好,烧制后瓷器显白而不返青。 高白泥烧制的白瓷杯从外观来看,色泽更白润。',
		ad:'卧足碗卧足碗是碗的一种式样。浅腹，碗底心内凹，以碗壁充当圈足，故称卧足碗。',
  }
}